module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ni-52cfeebfb0f78f395c1380c208ae088d.svg";